import React from 'react'

const SectionsPage = () => {
  return (
    <div>SectionsPage</div>
  )
}

export default SectionsPage